import { usePermissions } from "../../../server/auth/use-permissions";
import { useFlag } from "../../../server/optimizely";
import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { ChannelName } from "../../channels/types";
import { useAccountLimit } from "../../generic/hooks/use-account-limit";
import { SupabaseAccountService } from "../../generic/server/supabase-account-service";

export type AnalyticsTab = NonNullable<ChannelName> | "overview" | "surveys" | "mfai";
type AnalyticsPerms = AnalyticsTab[] | "loading" | "none";

export const useAnalyticsPerms = (): AnalyticsPerms => {
  const [analytics_tabs, , flagLoaded] = useFlag("analytics_tabs");
  const perms = usePermissions();
  const { data: listenEntitlement, loading: listenEntitlementLoading } =
    useAccountLimit("listen_entitlement");
  const channels = useSupabaseLoader(async ({ supabase, account_id }) => {
    return await new SupabaseAccountService(supabase).getEnabledChannels(account_id);
  }, []);
  console.log({ analytics_tabs, flagLoaded });

  if (!perms.super_admin && !perms.isLoading) return "none";
  if (channels.loading || listenEntitlementLoading || perms.isLoading || !flagLoaded) {
    return "loading";
  }

  return [
    "overview",
    ...(analytics_tabs ? ["mfai"] : []),
    ...(analytics_tabs && listenEntitlement && listenEntitlement !== "Disabled" ? ["surveys"] : []),
    ...(channels.data || []),
  ] as AnalyticsTab[];
};
